
import { CanActivateFn, Router } from "@angular/router";
import { GlobalValues } from '@app/_services/global-values';
import { inject } from '@angular/core';


export const roleGuard: CanActivateFn = async () => {
  const globalService = inject(GlobalValues);
  const router = inject(Router);

  if (!globalService.isMk3ITGroup && !globalService.isMk3ManagementGroup) {
    await globalService.loadUserRoles(); 
  }
  if (globalService.isMk3ITGroup || globalService.isMk3ManagementGroup) {
    return true;
  }

  router.navigate(['/']);
  return false;
};